<script setup>
import {defineProps, ref} from 'vue';
import {
  OnboardingMenuList,
  OnboardingMenuConst,
} from '../constants/OnboardingMenu';
import OnboardingDetails from '../components/onboarding/OnboardingDetails.vue';
import OnboardingAssignies from '../components/onboarding/OnboardingAssignies.vue';
import OnboardingQualification from '../components/onboarding/OnboardingQualification.vue';
import UserRoles from '../constants/UserRoles';
import {computed} from 'vue';

const props = defineProps({
  id: {
    type: Number,
    default() {
      return null;
    },
  },
  ownerId: {
    type: Number,
    default() {
      return null;
    },
  },
  assigneeId: {
    type: Number,
    default() {
      return null;
    },
  },
  permissions: {
    type: Object,
    default() {
      return null;
    },
  },
});

const tabMenus = ref([]);
const activeTabId = ref(OnboardingMenuConst.DETAIL);

if (props.permissions.details) {
  tabMenus.value.push(OnboardingMenuList[0]);
}
if (props.permissions.assignees) {
  tabMenus.value.push(OnboardingMenuList[1]);
}
if (props.permissions.qualification) {
  tabMenus.value.push(OnboardingMenuList[2]);
}

const setActiveTab = tabId => {
  activeTabId.value = tabId;
};
</script>
<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <nav
        id="navigation"
        role="navigation"
        aria-label="Topbar Menu"
        class="oxd-topbar-body-nav"
      >
        <ul>
          <template v-for="(tab, index) in tabMenus" :key="index">
            <li
              class="oxd-topbar-body-nav-tab"
              :class="{'--visited': activeTabId === tab.id}"
              @click="setActiveTab(tab.id)"
            >
              <span class="oxd-topbar-body-nav-tab-item">{{ tab.label }}</span>
            </li>
          </template>
        </ul>
      </nav>
      <br />
      <oxd-divider />
      <!-- DETAIL -->
      <OnboardingDetails
        v-if="
          activeTabId == OnboardingMenuConst.DETAIL && props.permissions.details
        "
        :id="props.id"
        :can-complete-task="props.permissions.is_assignee"
      />
      <!-- END: DETAIL -->
      <!-- ASSIGNIES -->
      <OnboardingAssignies
        v-if="
          activeTabId == OnboardingMenuConst.ASSIGNIES &&
            props.permissions.assignees
        "
        :id="props.id"
      />
      <!-- END: ASSIGNIES -->
      <!-- QUALIFICATION -->
      <OnboardingQualification
        v-if="
          activeTabId == OnboardingMenuConst.QUALIFICATION &&
            props.permissions.qualification
        "
        :id="props.id"
        :assignee-id="props.assigneeId"
        :is-assignee="props.permissions.is_assignee"
      />
      <!-- END: QUALIFICATIONS -->
    </div>
  </div>
</template>
<style scoped>
@media (min-width: 800px) {
  .oxd-topbar-body-nav-tab {
    position: relative;
  }
}
.oxd-topbar-body-nav ul:first-child {
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  padding: 0;
  margin: 0;
}
.oxd-topbar-body-nav-tab {
  height: 35px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  padding: 0 12px;
  margin-right: 15px;
  text-decoration: none;
  border-radius: 0.85rem;
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 600;
}
</style>
